export default __webpack_public_path__ + "static/favicon-5fdabd9b12d82240d1bfab05b98eb283.png";